import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.tsx';

export function GitHubCallbackPage() {
  const [searchParams] = useSearchParams();
  const { githubAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    // GitHub sends ?error=access_denied when user cancels
    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError(errorParam === 'access_denied' ? 'GitHub authorization was cancelled' : `GitHub error: ${errorParam}`);
      return;
    }

    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received from GitHub');
      return;
    }

    githubAuth(code)
      .then(() => navigate('/app', { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : 'GitHub authentication failed'));
  }, [searchParams, githubAuth, navigate]);

  if (error) {
    return (
      <div className="ds-auth-page">
        <div className="ds-auth-card">
          <div className="ds-auth-card__head">
            <h1 className="ds-auth-card__title">Authentication Failed</h1>
          </div>
          <div className="ds-auth-error">{error}</div>
          <Link to="/login" className="ds-btn ds-btn--primary ds-auth-form__submit" style={{ textAlign: 'center', textDecoration: 'none' }}>
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-auth-page">
      <div className="ds-auth-card" style={{ alignItems: 'center' }}>
        <div className="ds-auth-spinner" />
        <span className="ds-auth-status">Authenticating with GitHub...</span>
      </div>
    </div>
  );
}
